import { useMemo } from 'react'

import { withResourceRecords } from '@/shared/contexts'
import { useResourceRecordsContext } from '@/shared/hooks'
import { useGamificationPages } from '@/shared/lib/api/gamification-pages'
import { getShowTopLikesFromPage } from '@/features/custom-pages/lib/partnerPageFilters'

import { PartnersListScreen } from './components/PartnersListScreen'
import { getConfig } from './config'

export const DigitalProductPartners = withResourceRecords(() => {
  const {
    config: { humanName }
  } = useResourceRecordsContext()

  const { records: gamificationPages = [] } = useGamificationPages()
  const partnersPage = useMemo(
    () => gamificationPages.find(page => page.module_type === 'partners') ?? null,
    [gamificationPages]
  )
  const showTopLikes = partnersPage
    ? getShowTopLikesFromPage(partnersPage)
    : true

  return (
    <PartnersListScreen title={humanName.plural} showTopLikes={showTopLikes} />
  )
}, getConfig)
